var _style, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "392px",
    height: "422px",
    viewBox: "0 0 392 422",
    style: {
      enableBackground: "new 0 0 392 422"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#B8B20F;}\r\n\t.st5{fill:#FFFF00;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st6{fill:#1C77C9;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st7{fill:#29ABE2;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.83,227.14c-0.05-5.69,3.21-11.02,7.52-14.74c4.31-3.72,9.61-6.07,14.87-8.26c4.09-1.7,9-3.28,12.71-0.86 c4.28,2.79,4.22,8.97,3.66,14.05c-0.27,2.51-0.57,5.08-1.69,7.34s-3.29,4.18-5.81,4.29c4.67-1.33,9.34-2.66,14.01-3.99 c-2.81,6.28-8.26,11.33-14.74,13.64c6.77-0.05,13.53-1.4,19.81-3.95c-4.27,9.37-14.4,15.75-24.7,15.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.55,218.13c1.99-0.88,5.6-1.86,9.32-2.54c3.72-0.68,7.43-1.03,9.44-0.87c-0.2,0.48-0.7,1.02-1.48,1.59 c-1.65-0.14-4.74,0.14-7.82,0.71c-3.08,0.57-6.02,1.4-7.45,2.11c0.24-0.48-0.42-0.81-1.83-0.93c2.82-0.75,5.74-1.53,8.93-2.13 c3.19-0.6,6.72-0.98,7.88-0.7c-2.9,0.36-5.92,0.8-8.96,1.32c-1.11,0.19-2.26,0.39-3.27,0.65c-1.01,0.26-1.86,0.57-1.8,0.75 c2.34-0.33,4.76-0.89,7.14-1.37c2.38-0.48,5.2-0.92,6.52-0.82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M186.04,242.15c1.26-2.36,3.93-3.97,6.68-4.03c2.75-0.05,5.44,1.45,6.72,3.76c0.51,0.93,0.81,1.96,1.4,2.85 s1.58,1.64,2.68,1.53c-2.28,6.38-4.55,12.77-6.83,19.15c-3.71-5.23-8.12-10-13.09-14.16c1.27-2.73,1.98-5.68,2.09-8.65"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9837 -0.1797 0.1797 0.9837 -40.7498 31.2151)",
    className: "st7",
    cx: 151.93,
    cy: 240.55,
    rx: 33.3,
    ry: 33.45
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9837 -0.1797 0.1797 0.9837 -36.8768 45.155)",
    className: "st7",
    cx: 230.82,
    cy: 226.14,
    rx: 33.3,
    ry: 33.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.79,126.33c11.17-40.38,50.23-70.91,91.38-71.44s80.95,29,93.1,69.08c4.54-17.02,21.19-29.33,38.47-30.2 c17.28-0.87,34.27,8.81,44.17,23.27c9.9,14.47,13.03,33.12,10.32,50.54c-1.69,10.84-5.68,21.58-13.02,29.62 c-7.34,8.04-18.33,13.02-28.98,11.36c-12.01-1.88-21.64-11.74-26.74-22.98c-5.1-11.24-6.44-23.81-7.71-36.13 c-4.7,11.63-13.83,21-24.31,27.64c-10.48,6.64-22.29,10.77-34.18,14.12c-22.66,6.38-46.03,10.14-69.52,11.16 c-11.62,0.51-23.71,0.25-34.18-4.9c-11.17-5.5-19.15-15.89-26.29-26.23c-5.39-7.81-10.61-15.95-13.19-25.13s-2.22-19.65,3.01-27.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.54,204.56c-0.9,1.96-1.8,3.92-2.7,5.88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.84,202.72c-1.6,3.86-3.19,7.71-4.79,11.57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.95,201.34c0.28-0.45,0.56-0.9,0.84-1.35c-3.8,6.01-7.03,12.37-9.64,18.99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.09,198.99c-4.79,5.74-8.97,11.83-12.5,18.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.47,197.56c-3.17,5.98-6.34,11.95-9.5,17.93"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205.33,203.51c-5.41-0.29-10.76-1.49-15.78-3.54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.25,209.68c-7.8,1.89-16.56-0.89-21.84-6.94"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.91,214.6c-5.35,2.6-11.77,2.91-17.34,0.84s-10.24-6.48-12.6-11.94"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.74,260.72c-2.08,2.94-2.63,6.62-3.24,10.14c-4.22,24.46-14.12,48.65-32.21,66.04 c-18.09,17.39-45.26,26.88-69.84,20.28c-21.02-5.65-37.67-22.1-47.85-40.91c-10.18-18.81-14.71-39.95-18.54-60.86 s-7.13-42.11-15.14-61.88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.19,207.55c29.74-4.99,59.48-9.98,89.22-14.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.7ad3072d0a43eac1ff6aab4a245a3782.svg";
export { ForwardRef as ReactComponent };